module.exports = __webpack_public_path__ + "static/media/ep6.95b0e5d9.jpg";